import { render } from "./HelpAccount.vue?vue&type=template&id=7f63e1e8&scoped=true"
import script from "./HelpAccount.vue?vue&type=script&lang=js"
export * from "./HelpAccount.vue?vue&type=script&lang=js"

import "./HelpAccount.vue?vue&type=style&index=0&id=7f63e1e8&lang=scss&scoped=true"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f63e1e8"]])

export default __exports__